import type { Participant } from "./types";

/** Orange, deliberately unlike any colour a human participant can get. */
export const ASSISTANT_COLOR = "#d97706";

const PREFIX = "assistant:claude:";

export type AssistantParticipant = Participant & { ownerId: string; ownerName: string };

/** Every MCP connection belongs to the person who authorised it. */
export function assistantUser(ownerId: string, ownerName: string): AssistantParticipant {
  return {
    id: `${PREFIX}${ownerId}`,
    name: "Claude",
    avatarUrl: null,
    color: ASSISTANT_COLOR,
    ownerId,
    ownerName,
  };
}

export function isAssistantId(id: string): boolean {
  return id.startsWith(PREFIX);
}

export function assistantOwnerId(id: string): string | null {
  return isAssistantId(id) ? id.slice(PREFIX.length) : null;
}

/** Stable numeric awareness id, so an assistant keeps its slot across calls. */
export function assistantClientId(ownerId: string): number {
  let hash = 2166136261;
  for (let i = 0; i < ownerId.length; i += 1) {
    hash ^= ownerId.charCodeAt(i);
    hash = Math.imul(hash, 16777619);
  }
  // Keep it far away from the random client ids Yjs hands out to real clients.
  return 0x7000_0000 + (Math.abs(hash) % 0x0fff_ffff);
}
